<template>
  <div class="mt- flex w-full flex-col">
    <h1 class="title">Password Reset</h1>
    <Form
      @submit="onSubmit"
      :validation-schema="validationSchema"
      v-slot="{ errors }"
      class="mt-5 flex w-full flex-col gap-2 md:w-[500px]"
    >
      <p class="text-lg text-green-500" v-if="successChange">Password successfully changed</p>
      <p class="text-lg text-red-500" v-if="userNotFound">User not found</p>
      <p class="text-lg text-red-500" v-if="tooManyRequest">Too many request. Try again later</p>
      <div class="flex flex-col gap-2">
        <ErrorMessage name="password" />
        <Field
          name="password"
          type="password"
          @focus="userNotFound = false"
          placeholder="Password"
          class="input w-full"
          :class="errors.password && 'error'"
        />
      </div>
      <div class="flex flex-col gap-2">
        <ErrorMessage name="passwordConfirmation" />
        <Field
          name="passwordConfirmation"
          type="password"
          placeholder="Password Confirmation"
          @focus="userNotFound = false"
          class="input w-full"
          :class="errors.passwordConfirmation && 'error'"
        />
      </div>
      <button type="submit" class="button">Change</button>
    </Form>
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'
import { Field, Form, ErrorMessage } from 'vee-validate'
import { useRoute } from 'vue-router'
import * as yup from 'yup'
import { useMainStore } from '@/stores'
import { storeToRefs } from 'pinia'

const mainStore = useMainStore()
const { isRequesting, waitPreloaderTitle } = storeToRefs(mainStore)

const userNotFound = ref(false)
const successChange = ref(false)
const tooManyRequest = ref(false)

const route = useRoute()

const axios = inject('axios')

const validationSchema = yup.object({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters'),
  passwordConfirmation: yup
    .string()
    .required('Password Confirmation is required')
    .oneOf([yup.ref('password'), null], 'Passwords must match')
})

const onSubmit = (values) => {
  const { hash } = route.params

  isRequesting.value = true
  tooManyRequest.value = false
  userNotFound.value = false
  waitPreloaderTitle.value = 'Changing password...'

  values.hash = hash

  axios
    .post('/reset/password/complete', values)
    .then((response) => {
      if (response.data.status == 'success') {
        successChange.value = true
      }
    })
    .catch((error) => {
      if (error.response.status == 404 && error.response?.data?.status == 'error') {
        userNotFound.value = true
        successChange.value = false
      }
      if (error.response.status == 429 && error.response?.data?.status == 'error') {
        tooManyRequest.value = true
      }
    })
    .finally(() => {
      isRequesting.value = false
      waitPreloaderTitle.value = false
    })
}
//
</script>
